import React from 'react';
import { dropdowns, layouts, switches } from 'seal-ui-components';
import styled from 'styled-components';
import guid from '@Utils/commonUtils';
import style from './RadioMultiSelectDropdown.style';

const { CustomSelect, SelectOption } = dropdowns;
const { HorizontalBox, BoxText } = layouts;

const RadioMultiSelectDropdown = ({ id, name, options, setOptions, className, rest }) => {
    const handleChange = key => {
        const tempItems = options;
        const { selected, opposite } = options[key];

        if (opposite && !selected) {
            tempItems[key].selected = !selected;
            tempItems[opposite[0]].selected = false;
            tempItems[opposite[1]].selected = false;
        }

        setOptions({ ...tempItems });
    };

    const handleClear = () => {
        const tempItems = options;

        Object.keys(options).forEach(k => (tempItems[k].selected = false));
        setOptions({ ...tempItems });
    };

    const selectedLabelGenerator = () => {
        let selectedLabels = '';

        Object.values(options).forEach(option => {
            option.selected &&
                option.text !== 'No sorting' &&
                (selectedLabels += ` ${option.text},`);
        });

        selectedLabels = selectedLabels.substring(0, selectedLabels.length - 1);
        return selectedLabels.length > 0 ? selectedLabels : '';
    };

    const valueItemGenerator = (key, index) => (
        <SelectOption key={`${name}_${index}_${guid()}`} value={key} title={key}>
            {key.includes('header') ? (
                <BoxText>{options[key].text}</BoxText>
            ) : (
                <HorizontalBox>
                    <switches.Radio checked={options[key].selected} />
                    <BoxText data-testid={`${name}_dropdown_label_${index}`}>
                        {options[key].text}
                    </BoxText>
                </HorizontalBox>
            )}
        </SelectOption>
    );

    const selectOptions = Object.keys(options).map((key, index) => valueItemGenerator(key, index));

    return (
        <div className={className}>
            <CustomSelect
                key={id}
                value={selectedLabelGenerator()}
                placeholder={`Select ${name}`}
                multiple={false}
                paddedMenu={false}
                shortenText={true}
                size="large"
                appearance="secondary"
                optionsTextSize="small"
                onChange={handleChange}
                onClear={handleClear}
                {...rest}
            >
                {selectOptions}
            </CustomSelect>
        </div>
    );
};

export default styled(RadioMultiSelectDropdown)`
    ${style};
`;
